import features from './features/vacations-absences.features';
import components from './components/vacations-absences.components';
import common from './common/vacations-absences.common';
import VacationsAbsencesService from './vacations-absences.service';
import toastr from 'angular-toastr';
import toastUtils from './../common/utils/toastUtils';

let vacationsAbsencesModule = angular.module('vacations-absences', [
  common,
  features,
  components,
  toastr
])

  .config(($translatePartialLoaderProvider, toastrConfig, $windowProvider) => {
    'ngInject';
    toastUtils.setGlobalConfig(toastrConfig, $windowProvider.$get().isMobileApp);
    $translatePartialLoaderProvider.addPart('vacations-absences.module');
  })

  .service('vacationsAbsencesService', VacationsAbsencesService)

  .name;

export default vacationsAbsencesModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/vacations-absences.module.js